
import { RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { exists, ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { UserRoleAssignmentDto_$reflection, RoleDefinition_$reflection } from "../../../Shared/Roles.js";
import { list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../../Communication.js";
import { Storage_$reflection } from "../../../Shared/Storage.js";
import { Cmd_ofEffect } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export function init(roleId) {
    return [new State(roleId, new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), false), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(RoleDefinition_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/roles", (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(6, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(UserRoleAssignmentDto_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_3 = _arg_1;
            return (result_3.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_3.fields[0]);
            })())) : (Promise.resolve(result_3.fields[0]));
        });
    })), "/api/roles/assignments", (Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(6, [Item_3]))), Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_6), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_4) => {
        const pr_2 = response_4.arrayBuffer();
        return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item_4) => (new Msg(2, [Item_4])), (Item_5) => (new Msg(6, [Item_5])))]))];
}

export function update(msg, state) {
    let xs_2, xs;
    switch (msg.tag) {
        case 1:
            return [new State(state.RoleId, state.Roles, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.IsDeleteDialogOpen), Cmd_none()];
        case 2:
            return [new State(state.RoleId, state.Roles, state.Assignments, new RequestedValue$1(1, [msg.fields[0]]), state.IsDeleteDialogOpen), Cmd_none()];
        case 3:
            return [new State(state.RoleId, state.Roles, state.Assignments, state.Storages, true), Cmd_none()];
        case 4:
            return [new State(state.RoleId, state.Roles, state.Assignments, state.Storages, false), Cmd_none()];
        case 5:
            return [new State(state.RoleId, state.Roles, state.Assignments, state.Storages, false), (xs_2 = ["settings", "roles"], Cmd_ofEffect((_arg_1) => {
                RouterModule_nav(ofArray(xs_2), 1, 1);
            }))];
        case 6:
            return [state, Cmd_none()];
        default: {
            const roles = msg.fields[0];
            return [new State(state.RoleId, new RequestedValue$1(1, [roles]), state.Assignments, state.Storages, state.IsDeleteDialogOpen), exists((role) => equals(role.Id, state.RoleId), roles) ? Cmd_none() : ((xs = ["settings", "roles"], Cmd_ofEffect((_arg) => {
                RouterModule_nav(ofArray(xs), 1, 1);
            })))];
        }
    }
}

